import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';
import arrowIcon from '../../../assets/icons/breadcrumbs.svg';

const Breadcrumbs = ({ items }) => {
  return (
    <nav className="breadcrumbs">
      <div className="breadcrumbs-container">
        {items.map((item, index) => (
          <React.Fragment key={item.path}>
            {index > 0 && (
              <div className="breadcrumbs-separator">
                <img src={arrowIcon} alt=">" className="breadcrumbs-arrow" />
              </div>
            )}
            {index === items.length - 1 ? (
              <span className="breadcrumbs-current">{item.label}</span>
            ) : (
              <Link to={item.path} className="breadcrumbs-link">
                {item.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumbs;